import { IS_SUBJECT } from "./actionTypes";

export const isSubject = (type) => {
  return {
    type: IS_SUBJECT,
    payload: type,
  };
};
